/* @flow */

export const liveChatPlugin = 'live-chat';
export const liveChatScriptURL = 'https://embed.tawk.to/{property_id}/default';
